export default __webpack_public_path__ + "static/media/N-07.06d71c54.png";